<template>
  <div class="container-fluid p-3">  
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">DECLARACIÓN JURADA DE DOMICILIO</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Nombres:</label>
                <p>{{ persona.per_nombres }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Primer Apellido:</label> 
                <p>{{ persona.per_primer_apellido }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Segundo Apellido:</label> 
                <p>{{ persona.per_segundo_apellido }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Tipo Documento:</label>
                <p>{{ persona.tipo_documento }}</p>
              </div>
            </div> 
            <div class="row form-group"> 
              <div class="col-12 col-md-6">
                <label>Nro. Documento:</label>
                <p>{{ persona.per_numero_documento }}</p>
              </div>
            </div>
            
          </div>
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-6">
                <label>Fecha Nacimiento:</label>
                <p>{{ formatFecha(persona.per_fecha_nacimiento) }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-6">
                <label>Nacionalidad:</label>
                <p>{{ persona.nacionalidad }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col md-12">
            <b-tabs content-class="mt-3" v-model="tabHistorial">
              <b-tab title="NUEVA DECLARACIÓN">
                <div class="row mb-4 mt-4">
                  <div class="col-12 col-md-12">
                    
                    <div class="row form-group">
                      <div class="col-12 col-md-12">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="HOS"
                            name="tipo_domicilio"
                            id="rdHOS"
                            v-model="domicilio.tipo_domicilio"
                            @change="onChangeTipoDomicilio($event)"
                          />
                          <label class="form-check-label" for="rdHOS">Centro de Hospedaje</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="RES"
                            name="tipo_domicilio"
                            id="rdRES"
                            v-model="domicilio.tipo_domicilio"
                            @change="onChangeTipoDomicilio($event)"
                          />
                          <label class="form-check-label" for="rdRES">Domicilio Particular</label>
                        </div>
                      </div>
                    </div>

                    <CentroHospedaje :domicilio="domicilio" v-show="disabledHos==1"/>
                    <DomicilioParticular :domicilio="domicilio" v-show="disabledRes==1"/>

                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-12 text-right">
                    <router-link to="/analista/buscarPersona" class="btn btn-primary mr-2"><small>Cancelar</small></router-link> 
                    <button type="button" class="btn btn-success" @click="procesarDomicilio"><small>Registrar</small></button>
                  </div>
                </div>
              </b-tab>
              <b-tab title="HISTORIAL DE DECLARACIONES">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr class="text-center">
                          <th>#</th>
                          <th><small class="font-weight-bold text-info">HOSPEDAJE</small>/<small class="font-weight-bold text-primary">VIVIENDA</small></th>
                          <th><small  class="font-weight-bold">DIRECCION</small></th>
                          <th><small class="font-weight-bold">FECHA DECLARADA</small></th>
                          <th><small class="font-weight-bold">SANCION</small></th>
                          <th><small class="font-weight-bold">ACCIONES</small></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in domicilios" :key="index" :class="{ 'text-danger': item.multa }">
                          <!--1-->
                          <td class="text-center"><small>{{ index + 1 }}</small></td>
                          <!--2-->
                          <!-- <td v-if="item.tipo_domicilio =='ND'"><small>NO DECLARO DOMICILIO</small></td>                             -->
                          <!-- <td v-if="item.id_empresa == 0 && item.tipo_domicilio =='RES'"><small>{{item.domicilio}}</small></td>
                          <td v-if="item.id_empresa > 0 && item.tipo_domicilio =='HOS'"><small>{{item.emp_razon_social}}</small></td> -->
                          <td>
                            <small v-if="item.tipo_domicilio == 'ND'">NO DECLARO DOMICILIO</small>
                            <small v-else>{{item.domicilio}}</small>
                          </td>
                          <!--3-->
                          <td>
                            <small v-if="item.tipo_domicilio=='RES'">
                              {{item.direccion}} <br> 
                              <span class="text-muted">{{item.departamento}}</span>
                            </small>
                            <small v-if="item.tipo_domicilio=='HOS'">
                              {{item.direccion}} <br> 
                              <span class="text-muted">{{item.departamento+" - "+item.municipio}}</span>
                            </small>
                            <small v-if="item.tipo_domicilio=='HOS' && item.empresa_persona == 1">
                              {{item.direccion}} <br> 
                              <span class="text-muted">{{item.departamento}}</span>
                            </small>
                          </td>
                          <!--4-->
                          <td class="text-center">
                            <small v-if="item.tipo_domicilio != 'ND'">
                              {{"De: "+ item.fecha_inicio }} <br> 
                              {{"A: " + item.fecha_fin }}
                            </small>
                            <small v-else>
                              {{"Fecha de ingreso: "+ item.fecha_reg }}
                            </small>
                          </td>
                          <!--5-->
                          <td>
                            <small>
                              <span v-if="item.multa">Multa {{item.valor_multa_ufv}} UFV's</span>
                              <span v-else></span>
                            </small>
                          </td>
                          <!--6-->
                          <td class="text-center">
                            <span
                              v-if="!item.multa && $store.state.usuarioDB.id_rol != 5 && item.tipo_domicilio != 'ND'"
                              class="btn btn-outline-danger btn-sm mr-2"
                              title="Sanción"
                              @click="showModal(item)">
                              <i class="fa fa-credit-card"></i>
                            </span>

                            <a
                              class="btn btn-outline-info btn-sm mr-2"
                              title="Descargar"
                              v-if="item.revisado == '1' && item.tipo_domicilio != 'ND'"
                              
                              :href="url+item.id_persona+'/'+item.id_domicilios"
                            >
                            
                              <i class="fa fa-print"></i>
                            </a>
                            <small v-if="item.revisado==0" style="color:red;">Persona no Confirma Declaración</small>
                            <small v-if="item.revisado==2">Declaración Histórica</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      title="SANCIÓN"
      size="xl"
      hide-footer
      ref="modalSancion"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>{{ persona.per_nombres }}</td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ persona.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Nacionalidad:</th>
                <td>{{ persona.nacionalidad }}</td>
              </tr>

              <tr v-if="elegido.fecha_inicio">
                <th>Desde:</th>
                <td>{{ formatFecha(elegido.fecha_inicio) }}</td>
              </tr>
              <tr v-if="elegido.fecha_fin">
                <th>Hasta:</th>
                <td>{{ formatFecha(elegido.fecha_fin) }}</td>
              </tr>          
            </table>
          </div>
          <div class="col-6">
            <div class="alert alert-warning">
              <h5 class="text-dark text-justify">
                Si el ciudadano no declara su dirección en un máximo de dos días calendario, 
                o se verifica que su declaración no es real,
                es sujeto a sanción según art. 37 de la reglamentación de la ley 370.
              </h5>
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Observación de la sanción:</label>
              <textarea
                type="text"
                class="form form-control"
                v-model="elegido.observacion_sancion"
                placeholder="Indique motivos por los cuales se aplicará la sanción"
              ></textarea>
         
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModal" class="btn btn-secondary mr-4">Cerrar</a>
            <button @click="registrarSancion" :disabled="elegido.observacion_sancion==undefined " class="btn btn-danger">
              APLICAR SANCIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>  
    <Loading v-show="cargando"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
//const letras = helpers.regex("alpha", /^[a-zA-Z ]*$/);
import CentroHospedaje from '../../components/analista/CentroHospedaje';
import DomicilioParticular from '../../components/analista/DomicilioParticular';

export default {
  name: 'revisar',
  components: {
    Loading,
    CentroHospedaje,
    DomicilioParticular
  },
  data() {
    return {
      elegido: {},
      url: process.env.VUE_APP_URL + '/documento/2/',
      persona: {
        id_persona: 0,
        per_nombres: '',
        per_per_primer_apellido: '',
        per_per_segundo_apellido: '',
        per_fecha_nacimiento: '',
        per_email: '',
        par_tipo_documento: '',
        per_numero_documento: '',
        par_nacionalidad: '',
        tipo_persona: 3,
        
       
      },
      domicilio: {
        id_persona: 0,
        id_empresa: '',
        tipo_domicilio: 'HOS',
        nombre_domicilio: '',
        direccion: '',
        telefono: '',
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: '',
        nro_documento: '',
        departamento: '',
        empresa_persona: 0,
        
      },
      disabledHos: 1,
      disabledRes: 0,
      disabledND: 0,
      cargando: false,
      submitted: false,
      id: 0,
      domicilios: [],
      empresas: [],
      tabHistorial: 0,
      
    };
  },
  
  methods: {
    ...mapActions(["guardarUsuario"]),
    async getPersona(id) {
      try {
        let res = await this.axios.get(`/persona/${id}`);
        this.persona = res.data.contenido;
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async onLoadDomicilios(id) {
      try {
        let res = await this.axios.get(`/domicilio/${id}`);
        this.domicilios = res.data.contenido;
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async procesarDomicilio() {
      this.cargando = true;

      // Validaciones hospedaje
      if(this.disabledHos == 1){
        this.cargando = false;  
        //this.domicilio.nombre_domicilio = "";
        this.domicilio.nro_documento = "";

        if(this.domicilio.id_empresa == undefined || this.domicilio.id_empresa == 0){
          this.$swal({
            title: 'Información',
            text: 'Seleccione una empresa',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });

          return;
        }
      }

      if (this.disabledRes == 1) {
        this.cargando = false;
        this.domicilio.id_empresa = 0;
        if (
          this.domicilio.nombre_domicilio == undefined || this.domicilio.nombre_domicilio == "" ) {
          this.$swal({
            title: 'Información',
            text: 'Ingrese el nombre del hospedaje',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        if (this.domicilio.nro_documento == undefined || this.domicilio.nro_documento == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese el  número de carnet del titular.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        if (this.domicilio.direccion == undefined || this.domicilio.direccion == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese la dirección del hospedaje.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        if (this.domicilio.telefono == undefined || this.domicilio.telefono == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese el teléfono del hospedaje.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
      }

      if(this.disabledND == 1 ){
        this.cargando = false;
        this.extranjero.id_empresa = 0;
        this.domicilio.id_empresa = 0;
        this.domicilio.fecha_inicio = null;
        this.domicilio.fecha_fin = null;
      }
      else{
        this.cargando = false;
        // validacion para campos comunes para Hos, Res
        if (this.domicilio.departamento == undefined || this.domicilio.departamento == "") {
          this.$swal({
            title: 'Información',
            text: 'Seleccione Departamento.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        if (this.domicilio.fecha_inicio == undefined || this.domicilio.fecha_inicio == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese la fecha inicial.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        if (this.domicilio.fecha_fin == undefined || this.domicilio.fecha_fin == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese la fecha final.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
      }
    //console.log('extranjero: ', this.domicilio);
      
      try {
        let res = await this.axios.post(`/domicilioOperador`, this.domicilio);
        if (res.status === 200) {
          this.cargando = false;
          this.$swal({
            title: 'Información',
            text: 'Actualización correcta de domicilio',
            type: 'success',
            confirmButtonText: 'Aceptar'
          });
          //carga domicilios
          this.tabHistorial = 1;
          this.onLoadDomicilios(this.id);
          //this.getPersona(this.id);
        }
      } catch (error) {
        console.log('catch: ', error);
        this.cargando = false;
      }
    },
    onChangeTipoDomicilio(){
      let opcion = this.domicilio.tipo_domicilio;
      switch (opcion) {
        case 'HOS':
          this.disabledHos = 1;  
          this.disabledRes = 0;                  
        break;
        case 'RES':
          this.disabledHos = 0;  
          this.disabledRes = 1;
        break;
      }  
    },
    ofusca: function(cadena) {
      return window.btoa(cadena);
    },
    validaField(){
      if(this.disabledHos==1){
       // this.domicilio.nombre_domicilio = "";
        this.domicilio.nro_documento = "";
        if(this.domicilio.id_empresa == undefined || this.domicilio.id_empresa == 0){
          this.valid = false;
        }
      }
      if(this.disabledRes==1){
        this.domicilio.id_empresa = 0;
        if (this.domicilio.nombre_domicilio == undefined || this.domicilio.nombre_domicilio == "") {
          this.valid = false;
        }

        if (this.domicilio.nro_documento == undefined || this.domicilio.nro_documento == "") {
          this.valid = false;
        }
      }
      return this.valid;
    },

    formatFecha(event) {
      let str = event;
      if(str != "" && str != null){
        let arrayFecha = str.split("-");
        return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      }
      else{
        return '';
      }
      
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    showModal(item) {
      this.elegido = item;

      this.$refs["modalSancion"].show();
    },
    hideModal() {
      this.$refs["modalSancion"].hide();
    },
    async registrarSancion() {
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        observacion_sancion: this.elegido.observacion_sancion
      };

      try {
        this.resultados = await this.axios.put(`/updateMulta`, data);
        this.registros = this.resultados.data.contenido;

        this.hideModal();
        this.$swal({
          title: "<strong>SANCION Registrada</strong>",
          type: "success",
          html: `la sanción fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });

        this.onLoadDomicilios(this.id);
      } catch (error) {
        console.log(error);
      }
    },
    async getEmpresasHospedaje() {
      try {
        let resultado = await this.axios.get(`/empresa/empresaByRubro/3`);
        this.empresas = resultado.data.contenido;
      } catch (error) {
        console.log('catch', error);
      }
    },

  },
  created() {
    this.id = this.$route.params.id;
    console.log('id: ',this.id);
    this.domicilio.id_persona = this.id;
    this.getPersona(this.id);
    this.onLoadDomicilios(this.id);
    this.getEmpresasHospedaje();
    
    this.getTipoDocumento();

  },
  computed: {
    ...mapGetters(["estaActivo"])
  },

  validations: {
    domicilio: {
      tipo_domicilio: {required},
    },
  }
};
</script>
